import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { UserService } from '@frontend/sports/user/feature';
import { Store } from '@ngrx/store';
import { EpcotConfigService } from 'packages/sports/web/app/src/common/epcot-config.service';
import { Observable, map, switchMap } from 'rxjs';

import { AlertType } from '../../../alerts/models';
import { RewardTokensActions } from '../../../reward-tokens/actions';
import { BetslipErrorMessageFormatterService } from '../../../validation/services/formatting/betslip-error-message-formatter.service';
import { QuickBetActions } from '../../quick-bet-actions';
import { betPlacedResultSelector } from '../../quick-bet.selectors';

@Component({
    selector: 'bs-quick-bet-place-bet-warning',
    templateUrl: './quick-bet-place-bet-warning.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./quick-bet-place-bet-warning.component.scss'],
    standalone: false,
})
export class QuickBetPlaceBetWarningComponent {
    isEpcotEnabled = this.epcotConfigService.isEnabled();
    messages$: Observable<string[]>;
    alertType = AlertType.Information;

    constructor(
        public sitecore: Sitecore,
        public userService: UserService,
        private store: Store,
        private errorFormatter: BetslipErrorMessageFormatterService,
        private epcotConfigService: EpcotConfigService,
    ) {
        this.messages$ = this.store.select(betPlacedResultSelector).pipe(
            map((result) => result.warnings.map((y) => y.error)),
            switchMap((errors) => this.errorFormatter.getErrorsMessages(errors)),
        );
    }

    messageClick(event: MouseEvent): void {
        if (event && event.target) {
            if ((<Element>event.target).className.indexOf('viewbonus') > -1) {
                this.store.dispatch(QuickBetActions.viewBonus());
            }

            if ((<Element>event.target).className.indexOf('makedeposit') > -1) {
                this.store.dispatch(QuickBetActions.makeDeposit());
            }

            if ((<Element>event.target).className.indexOf('remove-token') > -1) {
                this.store.dispatch(RewardTokensActions.deselectAllToken());
            }
        }
    }
}
